import React from "react";
import {createRoot} from "react-dom/client";
import {Provider} from "jotai";
import {store} from "./state/global";
import App from "./App";
import NoSleep from "nosleep.js";
const NO_SLEEP = new NoSleep();

const container = document.getElementById("root");
const root = createRoot(container as Element);

// Enable wake lock on first click (anywhere).
// (must be wrapped in a user input event handler e.g. a mouse or touch handler)
document.addEventListener(
  "click",
  function enableNoSleep() {
    document.removeEventListener("click", enableNoSleep, false);
    console.log("enabling nosleep");
    NO_SLEEP.enable();
  },
  false
);

// top-level React.StrictMode

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
